import { PropsWithChildren } from 'react';
import type { ReactElement } from 'react';
import { getUniqueId } from '@micro-apps/env';

export interface Option {
	value: string;
	label: string;
	detail?: string;
	locale?: string;
	owsCode?: string;
}
export type Props = {
	options?: Option[];
	id?: string;
	className?: string;
	theme?: 'light' | 'dark';
	onChange?: (event: React.ChangeEvent<HTMLInputElement>, option: Option) => void;
};

export default function RadioButton({
	id = `${getUniqueId()}-RadioButtons`,
	options,
	className = '',
	theme = 'light',
	onChange,
}: PropsWithChildren<Props>): ReactElement {
	return (
		<div
			role="radiogroup"
			id={id}
			className={`RadioButtons RadioButtons--${theme} RadioButtons--${className}`}
		>
			{options &&
				options.length &&
				options.map((option, i) => (
					<div key={i} className="RadioButtons-button">
						<label className="RadioButtons-label" htmlFor={`${id}-${option.value}`}>
							<input
								className="RadioButtons-input"
								type="radio"
								name={id}
								value={option.value}
								id={`${id}-${option.value}`}
								onChange={e => {
									onChange && onChange(e, option);
								}}
								defaultChecked={i === 0}
							/>
							<span className="RadioButtons-decoration"></span>
							<span className="RadioButtons-bed-type">{option.label}</span>
							{option.detail && <span className="RadioButtons-price ty-c1">{option.detail}</span>}
						</label>
					</div>
				))}
		</div>
	);
}
